import styles from './authentication-profile.module.scss';
import { useContext, useState } from 'react';
import { WTypography } from '../../wrappers/wrapper';
import { UserContext } from '../../../contexts/userContext';
import { useNavigate } from 'react-router-dom';
import ConfirmDialog from '../../organisms/confirm-dialog/confirm-dialog';
import { localStorageService } from '../../../services/local-storage.service';
import Button from 'components/atoms/button/button';
import fnService from 'services/function.service';
import authService from 'services/auth.service';
import helperService from 'services/helper.service';
import { DEFAULT_HTTP_ERR_MESSAGE } from 'utils/constants';
import { TAxiosError } from 'models/common';

function AuthenticationProfile() {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);

  const handleDeactivateClicked = async () => {
    if (!user) return;

    setLoading(true);
    const token = authService.getToken();
    try {
      const res = await fnService.deactivateAccount(token!);
      localStorageService.clear();
      navigate('/login');
      helperService.showToast('success', res.message);
    } catch (error) {
      const err = error as TAxiosError;
      const errMessage = err.response?.data?.message || DEFAULT_HTTP_ERR_MESSAGE;
      helperService.showToast('error', errMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    setOpen(true);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <span className={styles.title}>Authentication</span>
        <WTypography className={styles.subTitle}>Deactivate account</WTypography>
        <WTypography className={styles.description}>
          Careful! This will permanently deactivate your account. You will no longer have access to
          this community after you do this.
        </WTypography>
        <Button
          loading={loading}
          disabled={loading}
          onClick={handleClick}
          type="dangerOutline"
          radius="10rem"
        >
          Deactivate my account
        </Button>
      </div>
      <ConfirmDialog
        open={open}
        setOpen={setOpen}
        onConfirm={handleDeactivateClicked}
        title="Deactivate Account"
        text="This action will permanently delete your account, do you wish to delete your account?"
        confirmText="Deactivate"
        isLeaveAction={false}
      />
    </div>
  );
}
export default AuthenticationProfile;
